<template>
  <div class="addEditCustomConfigTem">
    <p v-if="popStatu=='add'" class="titleP">{{ $t('adminView.add') }} {{ $t('company.CustomConfig') }}</p>
    <p v-if="popStatu=='edit'" class="titleP">{{ $t('adminView.Edit') }} {{ $t('company.CustomConfig') }}</p>
    <el-form ref="dialogForm" :inline="false" class="dialogForm" :model="popObj" label-position="left" label-width="auto" :rules="addCompanyRules">
      <el-row :gutter="40">
        <el-form-item :label="$t('company.Companyname')" prop="companyName">
          <el-input v-model="popObj.companyName" :disabled="true" maxlength="50" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('company.siteNameCn')" prop="siteName">
          <el-input v-model="popObj.siteName" maxlength="80" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('company.siteNameEn')" prop="siteNameEn">
          <el-input v-model="popObj.siteNameEn" maxlength="80" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('company.webUrl')" prop="webUrl" class="redStart">
          <el-input v-model="popObj.webUrl" maxlength="20" :placeholder="$t('company.enterLowercaseNum')" style="width:calc(80% - 150px);" @input="change($event)" />
          <span>{{ popObj.webUrl }}-drm.gpdcloud.net</span>
        </el-form-item>
        <el-form-item :label="$t('warningPage.Remark')" prop="mm">
          <el-input v-model="popObj.remark" :autosize="{ minRows: 3, maxRows: 8}" :placeholder="$t('warningSet.Pleaseenter')" style="width: 80%" type="textarea" />
        </el-form-item>
        <el-form-item :label="$t('adminView.JSONData')" prop="mm">
          <el-input v-model="popObj.extendValue" :autosize="{ minRows: 3, maxRows: 8}" :placeholder="$t('warningSet.Pleaseenter')" style="width: 80%" type="textarea" />
          <p>{{ $t('QR.ForExample') }}:  {"mailHost":"a","mailUsername":"b","mailPassword":"c"}</p>
        </el-form-item>
      </el-row>
      <el-row :gutter="40">
        <el-form-item label="LOGO">
          <el-upload class="upload-demo popUpload" action="" :auto-upload="false" :file-list="fileList1" :on-change="handleChange1" :on-remove="handleRemove1" list-type="picture">
            <el-button size="small" type="primary">{{ $t('company.uploadImg') }}</el-button>
            <div slot="tip" class="el-upload__tip">{{ $t('company.imgSize').replace('$1','1M').replace('$2','90*30') }}</div>
          </el-upload>
          <div v-if="!fileList1.length&&popObj.logo" class="imgBox">
            <img :src="popObj.logo" alt="LOGO" class="img">
            <i class="el-icon-close" @click="popObj.logo=''" />
          </div>
        </el-form-item>
        <el-form-item label="ICO">
          <el-upload class="upload-demo popUpload" action="" :auto-upload="false" :file-list="fileList2" :on-change="handleChange2" :on-remove="handleRemove2" list-type="picture">
            <el-button size="small" type="primary">{{ $t('company.uploadImg') }}</el-button>
            <div slot="tip" class="el-upload__tip">{{ $t('company.imgSize').replace('$1','200KB').replace('$2','128*128') }}</div>
          </el-upload>
          <div v-if="!fileList2.length&&popObj.ico" class="imgBox">
            <img :src="popObj.ico" alt="ICO" class="img">
            <i class="el-icon-close" @click="popObj.ico=''" />
          </div>
        </el-form-item>
        <el-form-item :label="$t('company.backgroundImage')">
          <el-upload class="upload-demo popUpload" action="" :auto-upload="false" :file-list="fileList3" :on-change="handleChange3" :on-remove="handleRemove3" list-type="picture">
            <el-button size="small" type="primary">{{ $t('company.uploadImg') }}</el-button>
            <div slot="tip" class="el-upload__tip">{{ $t('company.imgSize').replace('$1','2M').replace('$2','1920*1080') }}</div>
          </el-upload>
          <div v-if="!fileList3.length&&popObj.backgroundImage" class="imgBox">
            <img :src="popObj.backgroundImage" :alt="$t('company.backgroundImage')" class="img">
            <i class="el-icon-close" @click="popObj.backgroundImage=''" />
          </div>
          <!-- <img v-if="!fileList3.length&&popObj.backgroundImage" :src="popObj.backgroundImage" :alt="$t('company.backgroundImage')" class="img"> -->
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-preventReClick class="filter-item" type="primary" @click="submitPop('dialogForm')">{{ $t('button.Submit') }}</el-button>
    </div>
  </div>
</template>

<script>
import { uploadImg, addCustDeploymen, editCustDeploymen } from '@/api/company'
import i18n from '@/i18n'

export default {
  props: ['companyPopInfo', 'popStatu', 'customConfigPopShow'],
  data() {
    return {
      popObj: {
        companyId: null,
        companyName: null,
        siteName: null, // 系统名称
        siteNameEn: null,
        webUrl: null, // 域名
        logo: null,
        ico: null,
        backgroundImage: null,
        remark: null,
        id: null,
        extendValue: null
      },
      oldPopObj: {},
      userCompanyId: this.$store.state.companyId,
      fileList1: [],
      fileList2: [],
      fileList3: [],
      uploading: false
    }
  },
  computed: {
    addCompanyRules() {
      var checkWebUrl = (rule, value, callback) => {
        if (value === '' || !value) {
          callback(new Error(this.$t('lease.Cannotbeblanked2')))
        } else if (!/^[0-9a-z]{1,20}$/.test(value)) { // 请输入1~10位小写字母或者数字
          callback(new Error(this.$t('company.enterLowercaseNum')))
        } else {
          callback()
        }
      }
      return {
        webUrl: [{ validator: checkWebUrl, trigger: 'blur' }]
      }
    }
  },
  watch: {
    companyPopInfo: {
      handler(newValue, oldValue) {
        console.log('this.companyPopInfo', this.companyPopInfo)
        for (var attr in this.popObj) this.popObj[attr] = newValue.custDeployment ? newValue.custDeployment[attr] : newValue[attr]
        this.popObj.companyName = newValue.companyName
        this.popObj.companyId = newValue.id
        this.popObj.webUrl = this.popObj.webUrl ? this.popObj.webUrl.split('-')[0] : null
      },
      deep: true,
      immediate: true
    },
    customConfigPopShow(newVal) {
      if (!newVal) {
        for (var attr in this.popObj) this.popObj[attr] = this.oldPopObj[attr]
        this.fileList1 = this.fileList2 = this.fileList3 = []
      }
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.dialogForm.clearValidate()// 移除表单项的校验结果
        })
      }
    }
  },
  created() {
    this.oldPopObj = JSON.parse(JSON.stringify(this.popObj))
  },
  methods: {
    handleChange1(file, fileList) { // 上传弹窗
      this.uploadimg(file, 'fileList1', '1M')
      console.log('2:handleChange:file,fileList', file, fileList, this.fileList1)
    },
    handleChange2(file, fileList) { // 上传弹窗
      this.uploadimg(file, 'fileList2', '200KB')
    },
    handleChange3(file, fileList) { // 上传弹窗
      this.uploadimg(file, 'fileList3', '2M')
    },
    handleRemove1(file, fileList) { // 删除文件
      this.fileList1 = []
      this.popObj.logo = ''
      // console.log('handleRemove1:file,fileList', file, fileList, this.fileList1)
    },
    handleRemove2(file, fileList) { // 删除文件
      this.fileList2 = []
      this.popObj.ico = ''
    },
    handleRemove3(file, fileList) { // 删除文件
      this.fileList3 = []
      this.popObj.backgroundImage = ''
    },
    uploadimg(file, val, size) { // 上传文件
      var houzui = '' // 上传文件的格式
      if (file.name.indexOf('.') > -1) {
        var arr = file.name.split('.')
        houzui = arr[arr.length - 1].toLowerCase()
      }
      var realSize = parseInt(size)
      if (val == 'fileList2') realSize = realSize / 1024
      if (houzui != 'jpg' && houzui != 'png' && houzui != 'jpeg' && houzui != 'gif') { // 格式不对，请上传图片！
        this.$message({
          type: 'error',
          message: i18n.t('feedBack.formatWrong')
        })
        this[val] = this[val].length ? [this[val][0]] : []// 显示的图片：如有符合的图片则显示第一张，否则为空
        return
      } else if (file.size > realSize * 1024 * 1024) { // 图片大小不能超过5M，请重试！
        this.$message({
          type: 'error',
          message: i18n.t('feedBack.overSize').replace('10M', size)
        })
        this[val] = this[val].length ? [this[val][0]] : []
        return
      } else if (file.name.length > 100) { // 图片名称长度不能超过100，请重试！
        this.$message({
          type: 'error',
          message: i18n.t('company.imgNameLen')
        })
        this[val] = this[val].length ? [this[val][0]] : []
        return
      }
      file.childDir = 'custDeploymen'
      uploadImg(file).then(res => {
        if (res.resultCode == 1001) {
          this[val] = [file]
          if (val == 'fileList1') this.popObj.logo = res.resultModel
          if (val == 'fileList2') this.popObj.ico = res.resultModel
          if (val == 'fileList3') this.popObj.backgroundImage = res.resultModel
          // console.log('this[val]', this[val])
          // console.log('this.fileList1', this.fileList1)
          // console.log('this.fileList2', this.fileList2)
          // console.log('this.fileList3', this.fileList3)
        } else {
          this.$message({
            type: 'error',
            message: i18n.t('feedBack.ImgUploadFailed') // 图片上传失败，请重试！
          })
          this[val] = this[val].length ? [this[val][0]] : []
        }
      })
    },
    closePop() { // 新增/编辑公司信息弹窗--关闭
      this.$emit('closePop')
    },
    submitPop(formName) { // 新增/编辑公司信息弹窗--提交
      console.log('this.popObj', this.popObj)
      this.$refs[formName].validate((valid) => {
        if (valid && !this.isShowMustIntWarn) {
          var param = JSON.parse(JSON.stringify(this.popObj))
          param.updateBy = this.$store.state.userInfo.userLoginName
          param.updateTime = Date.now()
          param.webUrl = param.webUrl + '-drm.gpdcloud.net'
          // param.companyId=this.popObj.id
          if (this.popStatu == 'add') {
            param.id = null
            addCustDeploymen(param).then(res => {
              if (res.resultCode == 1001) {
                this.successFn()// 弹窗提交成功后，刷新页面
              } else {
                this.$message({
                  type: 'error',
                  message: res.resultMessage
                })
              }
            })
            return
          } else if (this.popStatu == 'edit') {
            editCustDeploymen(param).then(res => {
              if (res.resultCode == 1001) {
                this.successFn()// 弹窗提交成功后，刷新页面
              } else {
                this.$message({
                  type: 'error',
                  message: res.resultMessage
                })
              }
            })
          }
          console.log('param', param)
        }
      })
    },
    successFn() { // 弹窗提交成功后，调userInfoV3，并存储数据，刷新页面
      this.$message({
        message: this.$t('warningSet.submitted'),
        type: 'success'
      })
      this.$emit('closePop', 'needInt')
    },
    change(e) {
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
.addEditCustomConfigTem {
  .titleP {
    font-size: 16px;
    margin-bottom: 30px;
    text-align: center;
  }
  .el-row{
    width:calc(50% - 10px);
    margin:0!important;
    display: inline-block;
    vertical-align: top;
  }
  .dialogForm {
    display: flex;
    justify-content: space-between;
  }
  .dialog-footer{
    text-align: center;
  }
  .imgBox{
    overflow: hidden;
    z-index: 0;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    margin-top: 10px;
    padding: 10px;
    height: 92px;
    width: 92px;
    position: relative;
    &:hover{
      .el-icon-close{
        display: block;
      }
    }
    .el-icon-close{
      display: none;
      position: absolute;
      top: 5px;
      right: 5px;
      cursor: pointer;
      color: #606266;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: #d5d5d5;
      padding: 2px;
      z-index: 22;
    }
  }
  .img{
    width: 70px;
    height: 70px;
  }
}
</style>
